module.exports = __webpack_public_path__ + "static/img/wear-detect-airplus_se-en.a5d872c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/airplus_se/wear-detect-airplus_se-en.gif
// module id = vNzc
// module chunks = 1